import styled from 'styled-components';

import { InputBar } from '@xing-com/text-field';
import { spaceL } from '@xing-com/tokens';

const ControlledInputBar = styled(InputBar)`
  margin-bottom: ${spaceL};
`;

export const Styled = {
  ControlledInputBar,
};
